// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { cardListStyles } from "@conklin/Overrides/Widgets/SavedPayments/SavedPaymentsCardList";
import accordion from "@conklin/XDL/PreStyle/accordion";
import { fontConfig } from "@conklin/XDL/PreStyle/typography";
import { color, xScreen } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

cardListStyles.titleText = {
    variant: "h2",
    css: css`
        line-height: 36px;
        ${xScreen("lte", "sm")} {
            margin-bottom: 0;
        }
    `,
};

cardListStyles.sortBySelect = {
    labelPosition: "left",
    labelProps: {
        weight: fontConfig.weight.bold,
        css: css`
            width: auto;
            &&&& {
                padding-top: 4px;
            }
        `,
    },
    cssOverrides: {
        formField: css`
            margin-bottom: 16px;
            justify-content: flex-end;
            ${xScreen("lte", "sm")} {
                justify-content: flex-start;
            }
        `,
    },
};

cardListStyles.descriptionText = {
    variant: "h6",
    color: "common.white",
    css: css`
        margin: 5px 10px;
        max-width: calc(100% - 70px);
    `,
};

cardListStyles.useAsDefaultButton = {
    variant: "secondary",
    css: css`
        width: 100%;
        padding: 0 15px;
    `,
    typographyProps: {
        size: 14,
        weight: fontConfig.weight.bold,
    },
};

cardListStyles.billingAddressLabelText =
    cardListStyles.expirationLabelText =
    cardListStyles.nameOnCardLabelText =
        {
            weight: fontConfig.weight.bold,
            css: css`
                margin-bottom: 8px;
            `,
        };

cardListStyles.billingAddressText = cardListStyles.expirationText = {
    size: 14,
    css: css`
        line-height: 17px;
    `,
};

cardListStyles.nameOnCardText = {
    size: 14,
    css: css`
        margin-bottom: 20px;
        line-height: 17px;
    `,
};

cardListStyles.cardHeaderWrapper = {
    css: css`
        display: flex;
        align-items: center;
        max-width: calc(100% - 50px);
        border-right: 1px solid ${color("common.white")};
        width: 100%;
        min-height: 48px;
    `,
};

cardListStyles.accordionSection = {
    toggleTransition: {
        positionerCss: css`
            ${accordion.sectionDefaultProps?.toggleTransition?.positionerCss}
            position: static;
            border: 0;
        `,
    },
    headerProps: {
        css: css`
            &&&& button {
                padding: 0 0 0 12px;
                &:focus {
                    padding: 0 0 0 12px;
                }
            }
        `,
    },
};

cardListStyles.cardTypeImage = {
    imgProps: {
        style: {
            width: "auto",
            minWidth: "45px",
        },
    },
};
